module.exports = __webpack_public_path__ + "img/17.3e2d7a60.png";